import ChooseCourse from "../sections/chooseCourse"
// import AnimatedCourseGenerator from "../sections/animatedCourseGenerator"
import CampusLife from "../sections/campusLife"
import CourseGenerator from "../sections/courseGenerator"
import InternationalOffice from "../sections/internationalOffice"
import OurAlumni from "../sections/ourAlumni"
import OurEducators from "../sections/ourEducators"
import OurGraduates from "../sections/ourGraduates"
import OurPartners from "../sections/ourPartners"
import Scholarship from "../sections/scholarship"
import Hero from "../sections/hero"
import ScrollToTop from "../components/scrollToTop"
import AnimatedPage from "../components/animatedPage"
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from "react"
import { fetchHomepageData } from "../redux/slice/homepage"
import CourseGen from "../sections/courseGen"






const MainPage = () => {

    return (
        <AnimatedPage>
            {/* <ScrollToTop/> */}
            <Hero />
            
            <ChooseCourse />
            {/* <CourseGenerator /> */}
            {/* <CourseGen/> */}
            {/* <AnimatedCourseGenerator/> */}
            <div className="flex flex-col pt-12 bg-[#f3f3f3] relative">
                <CampusLife />
                <Scholarship />
            </div>
            <OurGraduates />
            <OurAlumni />
            <InternationalOffice />
            <OurEducators />
            <OurPartners />
        </AnimatedPage>
    )
}

export default MainPage